module.exports = __webpack_public_path__ + "img/character-dog-normal.48e26e38.svg";